import { render } from "./SubproductComponent.vue?vue&type=template&id=2bf62c68"
import script from "./SubproductComponent.vue?vue&type=script&lang=js"
export * from "./SubproductComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__